<template>
<div class="video-player-wrapper"  v-show="isShow" >
  <el-dialog size="tiny"
    :visible.sync="isShow"
    @close='handleClose'
  >
    <video
      id="myVideo"
      class="video-js vjs-big-play-centered vjs-fluid"
      controls
      preload="auto"
      width="100%"
      height="100%"
      :poster="posterUrl"
      ref="myvideojsPlayer" >
      <source
          type="video/mp4"
          :src="videoUrl" >
    </video>
  </el-dialog>
</div>
</template>

<script>

export default {
  name: 'PreviewVideo',
  props: {
    //海报图片url
    posterUrl: {
      type: String
    },
    //视频url
    videoUrl: {
      type: String
    },
    // 显示对话框
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return{
      isShow: this.visible
    }
  },
  mounted() {
    this.initVideo()
  },
  methods: {
    initVideo() {   //此处初始化的调用，我放在了获取数据之后的方法内，而不是放在钩子函数mounted
      //页面dom元素渲染完毕，执行回调里面的方法
      const that = this

      that.$nextTick(() => {
          console.log('*********************')
          that.videojs(document.getElementById('myVideo'), {
            //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
            controls: true,
            //自动播放属性,muted:静音播放
            autoplay: false,
            //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
            preload: "auto",
            //设置视频播放器的显示宽度（以像素为单位）
            width: "800px",
            //设置视频播放器的显示高度（以像素为单位）
            height: "400px",
            controlBar:{
              playToggle:true
            }
          },
          function onPlayerReady() {
            // 全局对象videojs(main.js中注入)
            that.videojs.log('播放器已经准备好了!');
          
            // In this context, `this` is the player that was created by Video.js.<br>  
            // 注意，这个地方的上下文， `this` 指向的是Video.js的实例对像player
            // this.play();
          
            // How about an event listener?<br>  // 如何使用事件监听？
            this.on('ended', function() {
              that.videojs.log('播放结束了!');
            })
          }
        )
      })
    },
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style>

</style>